import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Proyectos from "@/pages/proyectos/page";
import Proyecto from "@/pages/proyecto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/proyectos",
    element: <Proyectos />,
  },
  {
    path: "/proyectos/:slug",
    element: <Proyecto />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;